import { TableCell, styled } from "@mui/material";

export const SalaryTableCell = styled(TableCell)({
  padding: "8px 8px 0px 8px",
  borderBottom: "none",
});
